import React__default, { useRef } from 'react';
import { Menu, MenuList } from '@reach/menu-button';
import { KeyboardArrowDown } from 'emotion-icons/material';
import { Wrapper, GlobalStyles, MenuButton, MenuItem, InnerWrapper } from './Tabs.styles.js';
import Typography from '../Typography/index.js';

var ContentWithSelect = function ContentWithSelect(_ref) {
  var currentData = _ref.currentData,
    data = _ref.data,
    setCurrentData = _ref.setCurrentData;
  var ref = useRef();
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    className: "leshen-content-with-select-wrapper"
  }, /*#__PURE__*/React__default.createElement(GlobalStyles, null), /*#__PURE__*/React__default.createElement(Menu, {
    className: "menu"
  }, /*#__PURE__*/React__default.createElement(MenuButton, {
    className: "menu-button"
  }, data[currentData].title, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": true
  }, /*#__PURE__*/React__default.createElement(KeyboardArrowDown, {
    className: "keyboard-arrow-down"
  }))), /*#__PURE__*/React__default.createElement(MenuList, {
    className: "menu-list"
  }, data.map(function (tab, i) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      className: "menu-item",
      key: tab.title,
      selected: i === currentData,
      onSelect: function onSelect() {
        return setCurrentData(i);
      }
    }, tab.title);
  }))), /*#__PURE__*/React__default.createElement(InnerWrapper, {
    ref: ref,
    className: "inner-wrapper"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    className: "current-title"
  }, data[currentData].title), data[currentData].content));
};
var ContentWithSelect$1 = ContentWithSelect;

export { ContentWithSelect$1 as default };
//# sourceMappingURL=ContentWithSelect.js.map
